import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; 
import { doc, collection, onSnapshot, query, orderBy } from "firebase/firestore";

const FinancePage = ({ user }) => {
  const [currentTotal, setCurrentTotal] = useState(0);
  const [salesHistory, setSalesHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user?.uid) return;

    // --- LISTENER 1: Saldo Actual ---
    const businessDocRef = doc(db, 'businesses', user.uid);
    const unsubscribeCurrentTotal = onSnapshot(businessDocRef, (docSnap) => {
      if (docSnap.exists()) {
        setCurrentTotal(docSnap.data().currentSalesTotal || 0);
      }
    }, (err) => {
      console.error("Error escuchando el total de ventas:", err);
      setError("No se pudo cargar el total de ventas actual.");
    });

    // --- LISTENER 2: Historial de Cortes ---
    const historyColRef = collection(db, 'businesses', user.uid, 'salesHistory');
    const q = query(historyColRef, orderBy('cutoffDate', 'desc')); 
    
    const unsubscribeHistory = onSnapshot(q, (snapshot) => {
      const historyData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setSalesHistory(historyData);
      setLoading(false);
    }, (err) => {
      console.error("Error escuchando el historial de ventas:", err);
      setError("No se pudo cargar el historial de ventas.");
      setLoading(false);
    });

    return () => {
      unsubscribeCurrentTotal();
      unsubscribeHistory();
    };

  }, [user.uid]);

  const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return 'Fecha no disponible';
    return new Date(timestamp.seconds * 1000).toLocaleDateString('es-VE', {
      year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  if (loading && salesHistory.length === 0) {
    return <p>Cargando información financiera...</p>;
  }

  if (error) {
    return <p style={{color: '#dc3545'}}>{error}</p>;
  }

  return (
    <div className="finance-container">
      <h2>Reporte de Finanzas</h2>
      
      <div className="current-sales-card">
        <h3>Saldo Acumulado (Solo Repuestos)</h3>
        <p className="sales-total-display">$ {currentTotal.toFixed(2)}</p>
        <div style={{
            backgroundColor: '#e3f2fd', 
            color: '#0d47a1', 
            padding: '5px 12px', 
            borderRadius: '15px', 
            display: 'inline-block', 
            fontWeight: 'bold',
            fontSize: '12px',
            marginBottom: '10px'
        }}>
            Comisión CATALYST: 2%
        </div>
        <p style={{ fontSize: '13px', color: '#666', lineHeight: '1.4' }}>
          <strong>Nota importante:</strong> Este balance registra únicamente el valor de los repuestos vendidos. 
          Los montos por concepto de delivery no se incluyen en este acumulado ni están sujetos a comisión.
        </p>
      </div>

      <div className="history-section">
        <h3>Historial de Cortes Quincenales</h3>
        {salesHistory.length > 0 ? (
          <table className="history-table">
            <thead>
              <tr>
                <th>Fecha del Corte</th>
                <th>Monto Neto (Sin Delivery)</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {salesHistory.map(record => (
                <tr key={record.id}>
                  <td>{formatDate(record.cutoffDate)}</td>
                  <td className="amount-cell">$ {record.amount.toFixed(2)}</td>
                  <td>
                    <span style={{
                        backgroundColor: '#d4edda', 
                        color: '#155724', 
                        padding: '4px 8px', 
                        borderRadius: '4px', 
                        fontSize: '11px', 
                        fontWeight: 'bold'
                    }}>
                        PAGADO
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>Aún no hay historial de cortes para mostrar.</p>
        )}
      </div>
    </div>
  );
};

export default FinancePage;